webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(27);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueMaterial = __webpack_require__(31);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	var _vueI18n = __webpack_require__(26);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	__webpack_require__(15);
	
	__webpack_require__(16);
	
	__webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(_vueMaterial2.default);
	
	_vue2.default.material.registerTheme({
	  app: {
	    primary: 'orange',
	    accent: 'deep-purple'
	  }
	});
	
	var messages = {
	  en: __webpack_require__(9).default,
	  hu: __webpack_require__(10).default
	};
	
	var i18n = new _vueI18n2.default({
	  locale: 'en',
	  messages: messages
	});
	
	new _vue2.default({
	  i18n: i18n,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ex1.28b31ad.jpg";

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ex2.f2b36f7.jpg";

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ex3.f4a4d8a.jpg";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ex4.585820b.jpg";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ex5.c41c3cb.jpg";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ex6.16aa55d.jpg";

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		home: {
			title: "Personalized digital event guide",
			intro: "Conflive is a new event guide mobile application for modern conferences. It can be used to inform visitors, rate presentations, share related publications and display real-time quiz questions. It is a must have tool for all kind of events, as the most convenient way to communicate with the participants.",
			features: "Features",
			references: "References",
			referencesDesc: "Our latest supported event: Startup Safary 2017. The applications can be downloaded from these links:",
			team: "Our team",
			contact: "Contact",
			contactDesc: "Contact us for the pricing and more information.",
			feats: {
				"1title": "Schedule and list of speakers",
				"1desc": "Presenting the schedule information is the most important feature. Through this, the visitors can access contact information and attachments too.",
	
				"2title": "Sponsor categories",
				"2desc": "Beyond the information sharing, the application is a great advertising space for the sponsors. They can also be categorized based on their support level.",
	
				"3title": "Presentation ratings",
				"3desc": "Every presentation can be rated on a scale of 1-6 which can help your work to select the best ones for future events.",
	
				"4title": "Live presentation indicator",
				"4desc": "For freestyle events, it is necessary to show the current presentations. We display them right on the main screen, right on time.",
	
				"5title": "Related questions",
				"5desc": "We can attach questionaries to the presentations with single-select options. It can be used to check the understanding of the subject material or to organize small giveaways.",
	
				"6title": "Offline usage",
				"6desc": "The software was created with the use of modern toolkits, natively on iOS and Android platforms. After the first load, they can be used without internet access.",
	
				"7title": "Real time quiz",
				"7desc": "The visitors can answer the related questions in real-time, which can be presented directly on an external screen through a specialized web interface. This way, the speakers can reflect to their input during the presentations",
	
				"8title": "Location map",
				"8desc": "With multiple venue locations, it is necessary to display the exact position of the upcoming presentations. Our software can pair them with city maps and interior floor plans to indicate their location.",
	
				"9title": "Personalized features",
				"9desc": "Every event is different, this is why we always ready to develop new features. Just contact us to discuss your specific needs and create a new solution together."
			}
		}
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		home: {
			title: "Személyre szabott digitális programfüzet",
			intro: "A Conflive egy új programfüzet mobilalkalmazás, modern rendezvények számára. Segítségével a látogatók informálásán túl, az előadók is visszajelzést kaphatnak a munkájukról, megoszthatják a témához kapcsolódó anyagokat és valós idejű kérdőíveket közölhetnek. Egy konferencia alapeszköze a programfüzet digitális változata, mivel ez a legkézenfekvőbb felülete a kommunikációnak.",
			features: "A program funkciói",
			references: "Referenciák",
			referencesDesc: "Legutóbbi támogatott rendezvényünk: Startup Safary 2017. Az alkalmazások kipróbálhatóak az alábbi linkeken:",
			team: "Csapatunk",
			contact: "Kapcsolat",
			contactDesc: "További információkért és árajánlatkérésért forduljon hozzánk bizalommal.",
			feats: {
				"1title": "Előadó és előadás lista",
				"1desc": "A program információinak listázása a legfontosabb szolgáltatás. Ezen keresztül a látogatók elérhetik a kapcsolati adatokat és a csatolt fájlokat is.",
				"2title": "Szponzor kategóriák",
				"2desc": "Az adatok közlésén túl, a program kiváló reklámfelület a szponzorok számára. A hozzájárulásuk alapján több szintbe kategorizálhatjuk őket.",
				"3title": "Előadás értékelés",
				"3desc": "Minden előadásra hatos skálán visszajelzést küldhetnek a résztvevők, ezzel segítve a szervezők munkáját a jövőbeli program kialakításában.",
				"4title": "Aktuális előadás jelzése",
				"4desc": "Egy kötetlen rendezvény során elengedhetetlen hogy figyelemmel tudjuk követni az aktuálisan zajló előadásokat. Ezeket rögtön a főképernyőn, percre pontosan kijelzi a felületünk.",
				"5title": "Kapcsolódó kérdések",
				"5desc": "Az előadásokhoz kérdéssorokat is mellékelhetünk, egyszerű választási lehetőségekkel. Ezzel felmérhető az előadás anyagának megértése vagy akár nyereményjátékként is alkalmazható.",
				"6title": "Offline használat",
				"6desc": "A programok a legmodernebb fejlesztőeszközök felhasználásával készülnek, iOS és Android platformon. A felépítésüknek köszönhetően az első betöltés után akár internethozzáférés nélkül is működnek.",
				"7title": "Valós idejű kvízkérdések",
				"7desc": "A résztvevőknek lehetőségük van előadásokhoz tartozó kérdéseket azonnal megválaszolni, amiket prezentálhatunk rögtön például egy projektoron keresztül, így az előadó valós időben láthatja a résztvevők válaszait és reagálhat rá.",
				"8title": "Helyszín térkép",
				"8desc": "Több előadáshelyszín esetén az adatok feltüntetésén kívül, akár egy alaprajzon is jelezhetjük a soron következő előadásokat a résztvevőknek.",
				"9title": "Személyre szabott alkalmazás",
				"9desc": "Minden rendezvény más, emiatt folyamatosan készen állunk új funkciók fejlesztésére. Lépjen velünk kapcsolatba, hogy megbeszéljük az igényeket és együtt készítsünk egy új megoldást."
			}
		}
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Home = __webpack_require__(28);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'app',
		components: {
			Home: _Home2.default
		}
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vueCarousel3d = __webpack_require__(25);
	
	var images = __webpack_require__(32);
	
	exports.default = {
		name: 'home',
		components: {
			Carousel3d: _vueCarousel3d.Carousel3d,
			Slide: _vueCarousel3d.Slide
		},
		data: function data() {
			return {
				phoneOffset: -500,
				features: [{
					'icon': 'fa-bars',
					'title': 'home.feats.1title',
					'desc': 'home.feats.1desc'
				}, {
					'icon': 'fa-diamond',
					'title': 'home.feats.2title',
					'desc': 'home.feats.2desc'
				}, {
					'icon': 'fa-star-half-o',
					'title': 'home.feats.3title',
					'desc': 'home.feats.3desc'
				}, {
					'icon': 'fa-exclamation-triangle',
					'title': 'home.feats.4title',
					'desc': 'home.feats.4desc'
				}, {
					'icon': 'fa-question-circle',
					'title': 'home.feats.5title',
					'desc': 'home.feats.5desc'
				}, {
					'icon': 'fa-mobile-phone',
					'title': 'home.feats.6title',
					'desc': 'home.feats.6desc'
				}, {
					'icon': 'fa-clock-o',
					'title': 'home.feats.7title',
					'desc': 'home.feats.7desc'
				}, {
					'icon': 'fa-map',
					'title': 'home.feats.8title',
					'desc': 'home.feats.8desc'
				}, {
					'icon': 'fa-wrench',
					'title': 'home.feats.9title',
					'desc': 'home.feats.9desc'
				}],
				team: [{
					"name": "Dániel Eke",
					"desc": "CEO and software developer",
					"image": "ekedaniel.jpg"
				}, {
					"name": "Levente Bernáth",
					"desc": "Mobile development",
					"image": "bernathlevente.jpg"
				}, {
					"name": "Manó Barna Czár",
					"desc": "PR and tech support",
					"image": "barnamano.jpg"
				}]
			};
		},
	
		methods: {
			handleScroll: function handleScroll() {
				this.phoneOffset = Math.min(-(500 - window.scrollY), 0);
			},
	
			imgUrl: function imgUrl(path) {
				return images('./' + path);
			}
		},
		mounted: function mounted() {
			window.addEventListener('scroll', this.handleScroll);
		}
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/barnamano.ab2899c.jpg";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bernathlevente.99d5155.jpg";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ekedaniel.306d8ae.jpg";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/kovacsjulia.67e92b6.jpg";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.4f25708.png";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/phone.e74d742.png";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/szanthoandras.fbdc5a1.jpg";

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(14)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(11),
	  /* template */
	  __webpack_require__(30),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(13)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(12),
	  /* template */
	  __webpack_require__(29),
	  /* scopeId */
	  "data-v-72c085d8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "hero"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.title")))]), _vm._v(" "), _c('img', {
	    staticClass: "main-phone",
	    style: ({
	      marginTop: -500 - _vm.phoneOffset + 'px',
	      marginBottom: _vm.phoneOffset + 'px'
	    }),
	    attrs: {
	      "src": __webpack_require__(23)
	    }
	  })]), _vm._v(" "), _c('section', {
	    staticClass: "content column"
	  }, [_c('md-whiteframe', {
	    staticClass: "md-padding col-sm-8 col-sm-offset-2",
	    attrs: {
	      "md-elevation": "2"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('p', {
	    staticClass: "intro col-sm-8 col-sm-offset-2"
	  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("home.intro")) + "\n\t\t\t\t")])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.features")))]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.features), function(feature) {
	    return _c('div', {
	      staticClass: "feature col-md-4"
	    }, [_c('i', {
	      staticClass: "fa",
	      class: feature.icon,
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t(feature.title)))]), _vm._v(" "), (feature.extra) ? _c('div', {
	      staticClass: "extra"
	    }, [_c('span', [_vm._v("Extra funkció")])]) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t(feature.desc)) + "\n\t\t\t\t")])
	  }))]), _vm._v(" "), _c('md-whiteframe', {
	    staticClass: "references md-padding col-sm-8 col-sm-offset-2",
	    attrs: {
	      "md-elevation": "2"
	    }
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("home.references")))]), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("home.referencesDesc")) + "\n\n\t\t\t\t"), _c('div', {
	    staticClass: "row apps"
	  }, [_c('span', {
	    staticClass: "col-sm-6 col-xs-12"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://itunes.apple.com/us/app/startup-safary/id1225499566?mt=8",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-apple",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" iOS"), _c('br')])]), _vm._v(" "), _c('span', {
	    staticClass: "col-sm-6 col-xs-12"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://play.google.com/store/apps/details?id=com.conflive.safary",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-android",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Android"), _c('br')])])])]), _vm._v(" "), _c('carousel-3d', {
	    attrs: {
	      "width": 294,
	      "height": 522,
	      "autoplay": true,
	      "autoplay-timeout": 2000
	    }
	  }, [_c('slide', {
	    attrs: {
	      "index": 0
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1)
	    }
	  })]), _vm._v(" "), _c('slide', {
	    attrs: {
	      "index": 1
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(2)
	    }
	  })]), _vm._v(" "), _c('slide', {
	    attrs: {
	      "index": 2
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(3)
	    }
	  })]), _vm._v(" "), _c('slide', {
	    attrs: {
	      "index": 3
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(4)
	    }
	  })]), _vm._v(" "), _c('slide', {
	    attrs: {
	      "index": 4
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(5)
	    }
	  })]), _vm._v(" "), _c('slide', {
	    attrs: {
	      "index": 5
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(6)
	    }
	  })])], 1)], 1), _vm._v(" "), _c('md-whiteframe', {
	    staticClass: "contact md-padding col-sm-8 col-sm-offset-2",
	    attrs: {
	      "md-elevation": "2"
	    }
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("home.contact")))]), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("home.contactDesc"))), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "mailto:info@conflive.com"
	    }
	  }, [_vm._v("info@conflive.com")])])])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "nav"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://conflive.com",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(22)
	    }
	  })])])
	}]}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('home')], 1)
	},staticRenderFns: []}

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./barnamano.jpg": 18,
		"./bernathlevente.jpg": 19,
		"./ekedaniel.jpg": 20,
		"./ex1.jpg": 1,
		"./ex2.jpg": 2,
		"./ex3.jpg": 3,
		"./ex4.jpg": 4,
		"./ex5.jpg": 5,
		"./ex6.jpg": 6,
		"./kovacsjulia.jpg": 21,
		"./szanthoandras.jpg": 24
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 32;


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.0b25af9321c518093461.js